import { queryClient } from '@scout/identity'
import { Provider } from '@scout/ui'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, Outlet } from '@tanstack/react-router'

export const Route = createRootRoute({ component: RootLayout })

/**
 * The design system and the request plumbing, and nothing else.
 *
 * The chrome sits under `/admin` rather than here, because the way in is not
 * inside the console: a person who may not read the corpus has no sidebar to be
 * shown, and a shell wrapped around the sign-in page would offer them
 * navigation into pages that would only turn them away again.
 *
 * What both halves share is exactly what is here. The console is not the
 * product's AppShell dressed differently — an operator is not a buyer — but it
 * is the same design system and the same request plumbing, which is what keeps
 * the two surfaces from drifting into two looks and two ways in.
 */
function RootLayout() {
  return (
    <Provider>
      <QueryClientProvider client={queryClient}>
        <Outlet />
      </QueryClientProvider>
    </Provider>
  )
}
